import { render, staticRenderFns } from "./Recipe.vue?vue&type=template&id=0b8f444a"
import script from "./Recipe.vue?vue&type=script&lang=ts"
export * from "./Recipe.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports